const numberNotNeedingPadding = 10;
const secondsInHour = 3600;
const secondsInMinute = 60;

const padZero = (num: number): string => num >= numberNotNeedingPadding ? `${num}` : `0${num}`;

const formatTime = (totalSeconds: number): string => {
   const negative = totalSeconds < 0 ? '-' : '';
   const roundedTotalSeconds = negative ? Math.round(totalSeconds * -1) : Math.round(totalSeconds);
   const hoursPlace = Math.floor(roundedTotalSeconds / secondsInHour);
   const secondsWithoutHours = roundedTotalSeconds % secondsInHour;
   const minutesPlace = Math.floor(secondsWithoutHours / secondsInMinute);
   const secondsPlace = secondsWithoutHours % secondsInMinute;

   if (hoursPlace > 0) {
      return `${negative}${hoursPlace}:${padZero(minutesPlace)}:${padZero(secondsPlace)}`;
   } else if (minutesPlace > 0) {
      return `${negative}${minutesPlace}:${padZero(secondsPlace)}`;
   }

   return `${negative}00:${padZero(secondsPlace)}`;
};

const formatTimeForSpeech = (totalSeconds: number): string => {
   const negative = totalSeconds < 0 ? '-' : '';
   const roundedTotalSeconds = negative ? Math.round(totalSeconds * -1) : Math.round(totalSeconds);
   // eslint-disable-next-line no-magic-numbers
   return Math.floor(roundedTotalSeconds) === 0 ? '0 seconds' : new Date(roundedTotalSeconds * 1000).toISOString().substr(11, 8);
};

const getRoundedTime = (time: number): number => Math.floor(time * 1000) / 1000;

const getSecondsFromTimeString = (time: string): number => {
   const splitTime = time.split(':');
   const hours = parseInt(splitTime[0], 10);
   const minutes = parseInt(splitTime[1], 10);
   const seconds = parseFloat(splitTime[2]);

   return hours * 60 * 60 + minutes * 60 + seconds;
};

export default {
   formatTime,
   formatTimeForSpeech,
   getRoundedTime,
   getSecondsFromTimeString
};
